export var defaultComposeOptions = {
    className: process.env.NODE_ENV === 'production' ? '' : 'no-classname-🙉',
    classes: [],
    displayName: '',
    displayNames: [],
    mapPropsToStylesPropsChain: [],
    render: function () { return null; },
    handledProps: [],
    overrideStyles: false,
    slots: { __self: function () { return null; } },
    slotProps: [],
    state: function (props) { return props; },
    resolveSlotProps: function () { return ({}); },
    shorthandConfig: {},
};
//# sourceMappingURL=defaultComposeOptions.js.map